const GLOBAL_PRODUCT_COLLECTION = 'globalProductCollection';
const GLOBAL_PRODUCTS = 'globalProducts';

module.exports = {
  GLOBAL_PRODUCT_COLLECTION,
  GLOBAL_PRODUCTS,
};
